module.exports = __webpack_public_path__ + "static/media/bitmap.9e1f1f89.jpg";